import { useQuery } from "@tanstack/react-query";

import { retryRecoverableErrorOnce } from "@/config/query-client";
import { progressQueryOptions } from "@/domains/progress/factories/progress-query-options";

type UseProgressOptions = {
  enabled: boolean;
};

export const useProgress = ({ enabled }: UseProgressOptions) => {
  return useQuery({
    ...progressQueryOptions.current,
    enabled,
    retry: retryRecoverableErrorOnce,
  });
};
